import * as THREE from 'three'
import Part from './Part'
import Stage from 'components/Designer/Stage'
import { StageStateData } from 'components/Designer/Types'

class Model extends THREE.Group {
  stage: Stage
  uuid: string
  parts: THREE.Group
  baked: THREE.Group
  datatype: string
  version: string
  images: string[]
  precision_factor: number
  constructor({
    datatype,
    version,
    uuid,
    data,
    baked,
    images,
  }: StageStateData) {
    super()

    this.stage = Stage.getInstance()
    this.datatype = datatype
    this.uuid = uuid
    this.version = version
    this.images = images
    this.parts = new THREE.Group()
    this.baked = new THREE.Group()
    this.precision_factor = data ? data.precision_factor : 0.1
    

    if (baked) {
      const gltfLoader = this.stage.loaderGLTFLoader
      gltfLoader.load(`${baked}`, gltf => {
        this.baked.add(gltf.scene)
        this.stage.update()
      })
      this.add(this.baked)
    }

    if (data) {
      for (let partKey in data.structure[uuid]) {
        const uuid_part: string = partKey as string
        const part_structure = data.structure[uuid][uuid_part]
        const parmObject = {
          uuid: uuid_part,
          model: this,
          datatype: 'part',
          islands: data.islands,
          structure: part_structure,
        }
        const part = new Part({ ...parmObject })
        this.parts.add(part)
      }
      this.add(this.parts)
    }
  }
}

export default Model
